import React from 'react';
import styles from './styles.module.scss';
import MagiclinkComponent from './MagiclinkComponent';
import useTemplateData from '@/components/landing-page-templates/useTemplateData';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectCurrentUser } from '@/models/account';
import { makeSelectEventById } from '@/models/event';
import { useMemoizedSelector } from '@/hooks/use-memoized-selector';
import { getPageMetadataComp } from '@/utils/metadata';
import LandingPageLoader from '@/components/LandingPageLoader';

const MagicLinkPage = props => {
  const { isSpeakerPage } = props;
  const { eventId } = useParams<{ eventId: string }>();
  const currentUser = useSelector(selectCurrentUser);
  const templateData = useTemplateData(eventId);
  const event = useMemoizedSelector(makeSelectEventById, eventId);

  if (!templateData?.templateDetails?.eventLandingPageId) {
    return (
      <div className={styles.container}>
        <LandingPageLoader event={event} />
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <LandingPageLoader event={event} />
      {getPageMetadataComp({ eventId })}
      <MagiclinkComponent
        currentUser={currentUser}
        landingPageObject={templateData?.templateDetails}
        isSpeakerPage={isSpeakerPage}
      />
    </div>
  );
};

export default MagicLinkPage;
